import React from 'react'
import { Link } from 'react-router-dom'

import Services from '../../api/service';

// Adding comment to complete merge

const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const SubmitHandler = (e) => {
    e.preventDefault()
}

const Footer = ({logo, data}) => {
    return (
        <footer className="wpo-site-footer">
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-md-6 col-12 d-flex justify-content-center">
                            <div className="widget about-widget">
                                <div className="logo widget-title">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/index"><img src={logo} alt="" /></Link>
                                </div>
                                <ul className="info">
                                    <li>{data.info}</li>
                                </ul>
                                <div className="social">
                                    <ul>
                                        {data.socials.map((social, id) => (
                                        <li>
                                            <Link onClick={ClickHandler} to={social.link} key={id}>
                                                <i className={social.flaticon}></i>
                                            </Link>
                                        </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-12 d-flex justify-content-center">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>{data.quickLinkTitle}</h3>
                                </div>
                                <ul className='quickLinks'>
                                    {data.quickLinks.map((quickLink, id) => (
                                        <li key={id}><Link onClick={ClickHandler} to={quickLink.link}>{quickLink.name}</Link></li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        {/* <div className="col col-lg-3 col-md-6 col-12 col-md-6 col-sm-12 col-12">
                            <div className="widget newsletter-widget">
                                <div className="widget-title">
                                    <h3>Subscribe Newsletter</h3>
                                </div>
                                <p>Get timely updates ! We only send interesting and relevant emails.</p>
                                <form onSubmit={SubmitHandler}>
                                    <div className="input-1">
                                        <input type="email" className="form-control" placeholder="Your Email Address..."
                                            required="" />
                                    </div>
                                    <div className="submit clearfix">
                                        <button type="submit">Subscribe now</button>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col col-lg-6 col-md-12 col-12">
                            <ul>
                                <li>&copy; {new Date().getFullYear()} <Link onClick={ClickHandler} to="/">Collins Web Design LLC</Link>. All rights reserved.</li>
                            </ul>
                        </div>
                        <div className="col col-lg-6 col-md-12 col-12">
                            <div className="link">
                                <ul>
                                    {/* <li><Link onClick={ClickHandler} to="/privacy">Privace & Policy</Link></li>
                                    <li><Link onClick={ClickHandler} to="/terms">Terms</Link></li> */}
                                    <li><Link onClick={ClickHandler} to="/about">About us</Link></li>
                                    {/* <li><Link onClick={ClickHandler} to="/faq">FAQ</Link></li> */}
                                    <li><Link onClick={ClickHandler} to="/volunteer">Volunteer</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;